export const API_URL = 'https://acore-api.thomines.fr';
export const SERVER_NAME = 'wotlk.thomines.fr';
export const PULSE_DAYS = 7;
export const ENABLE_AZEROTH_THEME = false;
